// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"B0-z"};